<template>
    <b-overlay :show="loading || typeLoading" opacity="0.2">

        <b-modal id="edit-score" title="Puantaj Düzenle" scrollable no-close-on-esc no-close-on-backdrop>
            <not-driver-monthly-update-score v-model="score" :types="types"></not-driver-monthly-update-score>
            <template #modal-footer>
                <v-executer :disabled="score.Locked" text="Güncelle" :action="updateScore" :loading="presaving">
                    <div v-if="score.Locked" class="d-flex align-items-center g-50">
                        <feather-icon icon="LockIcon"></feather-icon>
                        Puantaj Kilitli
                    </div>
                    <template v-else>Güncelle</template>
                </v-executer>
            </template>
        </b-modal>

        <b-modal id="score-errors" body-class="p-75" :title="scoreErrors.EmployeeName ? `Puantaj Hataları - ${scoreErrors.EmployeeName}` : 'Puantaj Hataları'" hide-footer scrollable no-close-on-esc no-close-on-backdrop>
            <not-driver-monthly-score-error :errors="scoreErrors.Errors" :month="[showingMonth >= 10 ? showingMonth : [0,showingMonth].join(''),showingYear].join('/')"></not-driver-monthly-score-error>
        </b-modal>

        <b-modal v-if="additional.TIP == 1 && additional.SIRA_NO==35" id="additional" size="sm" :title="(additional.TIP == 1 && additional.SIRA_NO==35) ? 'Fazla Mesai Düzenle' : 'Hafta Tatili Mesaisi Düzenle'" scrollable no-close-on-esc no-close-on-backdrop>
            <not-driver-monthly-additional v-model="additional"></not-driver-monthly-additional>
            <template #modal-footer><v-executer text="Kaydet" :action="createAdditional" :loading="additionalCreating"></v-executer></template>
        </b-modal>

        <div class="row px-1 pt-1">
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="month">
                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                </select>
            </div>
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="year">
                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                </select>
            </div>
            <div class="col-md-auto mb-1 mb-md-0" v-if="exitAction == null">
                <select class="form-control bg-img-none" v-model="branchType">
                    <option value="O">Org. Şube</option>
                    <option value="S">SGK Şube</option>
                </select>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'O'">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'S'">
                <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null">
                <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null">
                <b-input-group class="input-group-merge v-table-search-input">
                    <template #prepend>
                        <b-input-group-text >
                            <feather-icon icon="SearchIcon"></feather-icon>
                        </b-input-group-text>
                    </template>
                    <b-form-input v-on:keyup.enter="checkUnsavedAndGetAll" v-model="searchValue" placeholder="Ara..." ></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <button class="btn btn-success btn-block" v-on:click="checkUnsavedAndGetAll">
                    Sorgula
                </button>
            </div>
        </div>

        <div class="sticky-status border-bottom pt-25">
            <div class="date-header text-muted font-weight-bolder px-1 pt-1">
                <span class="material-icons-round text-secondary">calendar_month</span>
                {{showingMonth >= 10 ? showingMonth : [0,showingMonth].join('')}}/{{showingYear}}
            </div>

            <div class="px-1" v-if="(types || []).length">
                <vue-perfect-scrollbar>
                    <div class="d-flex g-25 mb-75 mt-75 w-100" >
                        <div v-for="(type,index) in types" :key="index" class="type d-flex align-items-center py-25 pl-25 pr-50 text-nowrap" :class="`type-bg-${type.Color}`">
                            <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                            {{$safe(type,'Name')}}
                        </div>
                    </div>
                </vue-perfect-scrollbar>
            </div>
        </div>

        <vue-perfect-scrollbar tag="div" class="overflow-hidden">
            <table class="table table-sm table-hovered bordered-header mb-1 score-table">
                <thead>
                    <tr>
                        <th rowspan="2" class="align-middle">Durum</th>
                        <th class="column-sticky align-middle">Personel</th>
                        <th rowspan="2" class="align-middle text-nowrap">Kimlik Numarası</th>
                        <th rowspan="2" class="align-middle text-nowrap">Org. Şube</th>
                        <th rowspan="2" class="align-middle text-nowrap">SGK Şube</th>
                        <th rowspan="2" class="align-middle text-nowrap">Yaka</th>
                        <th class="text-nowrap" v-for="day in daysOfMonth" :key="day" :colspan="values.length">
                            <template v-if="getDayIsHoliday(day)">
                                <div class="d-flex align-items-center text-danger" v-b-tooltip.noninteractive.hover.bottom="getDayIsHoliday(day)">
                                    {{day}} {{ getDayName(day) }}
                                    <feather-icon icon="InfoIcon" class="ml-50"></feather-icon>
                                </div>
                            </template>
                            <template v-else>
                                {{day}} {{ getDayName(day) }}
                            </template>
                        </th>
                        <th class="bg-light-secondary" :colspan="(c_types || []).length">Özet</th>
                        <th rowspan="2" class="align-middle text-nowrap text-primary" v-b-tooltip.noninteractive.hover.bottom="'FAZLA MESAİ'">FM (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap text-secondary" v-b-tooltip.noninteractive.hover.bottom="'HAFTA TATİLİ MESAİSİ'">HTM (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'GENEL TATİL MESAİSİ'">GTM (Saat)</th>
                    </tr>
                    <tr>
                        <th class="column-sticky">
                            <button class="btn btn-sm text-nowrap btn-dark p-25" v-on:click="selectAll">Tümünü Seç</button>
                        </th>
                        <template v-for="day in daysOfMonth">
                            <th v-for="(value,index) in values" class="text-center" :key="day + index" v-b-tooltip.noninteractive.hover.bottom="value.text" :class="value.color">{{value.short}}</th>
                        </template>
                        <template v-for="type in c_types">
                            <th  class="align-middle text-nowrap">{{ $safe(type,'Name') }}</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in serverData" :key="d.DriverCardNumber">
                        <td class="text-nowrap">
                            <div class="d-flex align-items-center justify-content-center">
                                <span class="material-icons-outlined mr-50 text-secondary" v-b-tooltip.noninteractive.hover.right="'İlgili şube ve ay için puantaj kilitlidir.'" v-if="d.Locked">lock</span>
                                <span class="material-icons-outlined mr-50 text-danger c-pointer" v-on:click="showErrors(d)" v-else-if="d.DayErrors.length" v-b-tooltip.noninteractive.hover.right="`Toplam ${d.DayErrors.length} adet puantaj hatası bulunmaktadır.`" >report_gmailerrorred</span>
                                <span class="material-icons-outlined mr-50 text-success" v-b-tooltip.noninteractive.hover.right="'Sürücü puantaj bilgisi kaydedilebilir.'" v-else>check_circle</span>
                            </div>
                        </td>
                        <td class="text-nowrap column-sticky">
                            <div class="d-flex align-items-center">
                                <b-form-checkbox :disabled="(d.DayErrors.length != 0 || d.Locked)" v-model="d.Selected">
                                    {{$safe(d,'Employee.FirstName') &&  $safe(d,'Employee.LastName') ? [$safe(d,'Employee.FirstName'),$safe(d,'Employee.LastName')].join(' ') : d.DriverFullName}}
                                </b-form-checkbox>
                            </div>
                        </td> 
                        <td>
                            {{$safe(d,'Employee.IdentityNumber') || '-'}}
                        </td>
                        <td v-b-tooltip.hover.bottom.html="[
                            '<div class=\'text-left\'>',
                            [`Giriş: ${ d.OStartDateStr || '-' }`,`Çıkış: ${ d.OEndDateStr || '-' }`,].join('<br/>'),
                            '</div>'
                            ].join('')"">
                            {{$safe(d,'OBranch.Name') || '-'}}
                        </td>
                        <td v-b-tooltip.hover.bottom.html="[
                            '<div class=\'text-left\'>',
                            [`Giriş: ${ d.SGKStartDateStr || '-' }`,`Çıkış: ${ d.SGKEndDateStr || '-' }`,].join('<br/>'),
                            '</div>'
                            ].join('')"">
                            {{$safe(d,'SGKBranch.Name') || '-'}}
                        </td>
                        <td>
                            <div class="d-flex justify-content-center">
                                <collar-status :code="$safe(d,'CollarStatus.Code')" small :name="$safe(d,'CollarStatus.Name')"></collar-status>
                            </div>
                        </td>
                        <template v-for="(day,rowIndex) in daysOfMonth">
                            <template v-if="$safe(d.Days[day],'DayIsBefore') == false">
                                <td :colspan="values.length" :key="d.DriverCardNumber + day + 'is-before'" class="text-center align-middle border-right">
                                    <span class="material-icons-round d-block text-muted" v-b-tooltip.noninteractive.hover.bottom="`${day} tarihi için henüz çalışma kaydı girilemez.`">event_busy</span>
                                </td>
                            </template>
                            <template v-else-if="$safe(d.Days[day],'Working')">
                                <template v-for="(value,index) in values">
                                    <td     class="text-center cell-group position-relative" 
                                            v-on:click="edit(d,day,d.Days[day])" 
                                            :title="day" 
                                            :key="d.DriverCardNumber + day + index" 
                                            :data-cell-group="[d.Employee.IdentityNumber || '',day,rowIndex].join('-')" 
                                            :data-index="index" 
                                            @mouseover="hover" 
                                            @mouseleave="unhover" 
                                            :class="[
                                                $safe(d.Days[day][value.value],'Type.Color') ? ['type',$safe(d.Days[day][value.value],'Type.Color')].join('-') : null,
                                                d.Days[day].HasConflict ? `nd-score-error-${index}`:null,
                                                value.value == 'Score' ? 'font-weight-bolder border-right' : null,
                                                d.Days[day].IhbarOneli ? `nd-score-ihbar-${index}`:null
                                            ]">
                                        {{$safe(d.Days[day][value.value],'Type.Code') || "-"}}
                                        <template v-if="value.value == 'Score'">
                                            <template v-if="$safe(d.Days[day],'HTM') != null">
                                                <span class="small-box type-gray">H</span>
                                            </template>
                                            <template v-else-if="$safe(d.Days[day],'GTMFM') != null || $safe(d.Days[day],'GTM') != null">
                                                <span class="small-box type-purple">RT</span>
                                            </template>
                                        </template>
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <td :key="d.DriverCardNumber + day" :colspan="values.length" v-on:click="$safe(d.Days[day],'HasNoData') == false && edit(d,day,d.Days[day])" class="bg-light text-center align-middle border-right c-pointer">
                                    <span class="material-icons-round d-block text-secondary" v-if="$safe(d.Days[day],'HasNoData') == false" v-b-tooltip.noninteractive.hover.bottom="`${day} tarihinde sigorta kaydı olmadığı halde günlük çalışma kaydı bulunmaktadır.`">error_outline</span>
                                </td>
                            </template>
                        </template>
                        <template v-for="(t,i) in c_types">
                            <td>{{ $safe(d,`Totals.${t.TIP}${t.SIRA_NO}`) || 0 }}</td>
                        </template>
                        <td>
                            <div class="d-flex align-items-center">
                                <button :disabled="d.Locked" v-on:click="editAdditional(d,1,35)" class="btn btn-xs mr-25 btn-icon btn-flat-primary" v-b-tooltip.noninteractive.hover.bottomright title="Fazla Mesai Düzenle">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <span class="font-weight-bolder text-nowrap">{{$safe(d,'TotalFMStr') || '0'}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <!-- <button :disabled="d.Locked" v-on:click="editAdditional(d,1,10)" class="btn btn-xs mr-25 btn-icon btn-flat-secondary" v-b-tooltip.noninteractive.hover.bottomright title="Hafta Tatili Mesaisi Düzenle">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button> -->
                                <span class="font-weight-bolder text-nowrap">{{$safe(d,'TotalHTMStr') || '0'}}</span>
                            </div>
                        </td>
                        <td>
                            <span class="font-weight-bolder">{{$safe(d,'GTMStr') || '0'}}</span>
                        </td>
                    </tr>
                    <tr v-if="serverData.length == 0">
                        <td class="text-center" colspan="122">Herhangi bir veri bulunamadı.</td>
                    </tr>
                </tbody>
            </table>
        </vue-perfect-scrollbar>
        <div class="d-flex g-50 px-50">
            <div class="cell-error-indicator px-75 py-25 rounded text-danger d-flex align-items-center g-50">
                <span class="material-icons-outlined cell-indicator-icon">cancel</span>
                Puantaj Hatası
            </div>
            <div class="cell-ihbar-indicator px-75 py-25 rounded text-info d-flex align-items-center g-50" v-if="exitAction">
                <span class="material-icons-outlined cell-indicator-icon">info</span>
                İhbar Öneli Süresi
            </div>
        </div>
        <div class="d-flex justify-content-between p-1">
            <div class="d-flex align-items-center text-nowrap per-page">
                <span>Toplam {{total}} kayıt arasından</span>
                <select class="form-control form-control-sm mx-50" v-model="perPage">
                    <option v-for="pp in perPages" :value="pp" :key="pp">{{pp}}</option>
                </select>
                <span>gösteriliyor.</span>
            </div>
            <b-pagination :total-rows="total" v-model="currentPage" :per-page="perPage" class="mb-0" v-on:change="$nextTick(()=>{ checkUnsavedAndGetAll() })">
                <template #page="{page}">
                    {{page}}<span class="text-secondary">{{hasUnsavedItem(page) ? '*':''}}</span>
                </template>
            </b-pagination>
        </div>
        <div class="text-right px-1 pb-1 pt-50">
            <v-executer :loading="saving" :action="create" :disabled="c_selected == 0" :text="`Seçilenleri (${c_selected} Personel) Kaydet`"></v-executer>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay, VBTooltip, BPagination, BFormCheckbox,BInputGroupText, BInputGroup, BFormInput,  } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import NotDriverMonthlyScoreError from './NotDriverMonthlyScoreError.vue'
import NotDriverMonthlyUpdateScore from './NotDriverMonthlyUpdateScore.vue'
import NotDriverMonthlyAdditional from './NotDriverMonthlyAdditional.vue'
import SystemData from '@/api/system-data'
import CollarStatus from '../../components/CollarStatus.vue'

export default {
    components:{
        BOverlay,
        BPagination,
        BFormCheckbox,
        VuePerfectScrollbar,
        NotDriverMonthlyScoreError,
        NotDriverMonthlyUpdateScore,
        BInputGroupText,
        BInputGroup, 
        BFormInput,
        NotDriverMonthlyAdditional,
        CollarStatus
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        months:Array,
        exitAction:[Object, null],
        typeLoading:{
            type:Boolean,
            default:false
        },
        types:{
            type:Array,
            default:()=>[]
        },
        branches:{
            type:Array,
            default:()=>[]
        },
        sbranches:{
            type:Array,
            default:()=>[]
        },
        collarStatuses:{
            type:Array,
            default:()=>[]
        },
    },
    watch:{
        exitAction(n,o){
            if(n != null && o == null){
                this.getAllMonthly()
            }
        }
    },
    data(){
        return{
            loading:false,
            saving:false,
            serverData:[],
            year:null,
            years:[],
            showingYear:null,
            showingMonth:null,
            month:null,
            daysOfMonth:[],
            total:1,
            currentPage:1,
            perPage:10,
            perPages:[10,20,30,40],
            branchType:'O',
            values:[
                {
                    value:"DailyCheckStatus",
                    text:"Günlük Puantaj",
                    short:"G",
                    color:"text-warning"
                },
                {
                    value:"Score",
                    text:"Maaşa Esas Puantaj",
                    short:"M",
                    color:"text-success"
                }
            ],
            scoreErrors:{
                EmployeeName:null,
                Errors:[]
            },
            score:{
                Driver:null,
                Employee:null,
                Day:{
                    Date:null,
                    DailyCheckStatus:{Type:{Code:null}},
                    Score:{Type:{Code:null}},
                },
                WorkedTime:null,
                GTM:null,
                SGKEksikGunId:null,
                IsHTM:null,
                IsGTM:null,
                Locked:false,
                BranchId:null,
                SGKJobNoticeId:null
            },
            presaving:false,
            searchValue:null,
            searchTimer:null,
            branch:null,
            sbranch:null,
            additional:{
                EmployeeId:null,
                Month:null,
                Year:null,
                Time:null,
                SystemCalculated:null,
                TIP:null,
                SIRA_NO:null,
                BranchId:null,
                SGKJobNoticeId:null,
            },
            additionalCreating:false,
            holidays:[],
            collarStatus:null
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        this.getHolidays()
    },
    methods:{
        getDayIsHoliday(d){
            return this.holidays.find(h=>moment(d,'DD.MM.YYYY').isBetween(moment(h.Start,'YYYY-MM-DD'),moment(h.End,'YYYY-MM-DD'),null,"[)"))?.Name || null
        },
        getHolidays(){
            SystemData.GetHolidays().then(res=>{
                this.holidays = res.data?.Data?.items?.map(h=>{
                    return {
                        Start:h.start.date ? moment(h.start.date,'YYYY-MM-DD').format('YYYY-MM-DD') : null,
                        End:h.end.date,
                        Name:h.summary
                    }
                }) || []
            })
        },
        clearForm(){
            this.score.Driver = null
            this.score.Day.Date = null
            this.score.Day.DailyCheckStatus.Type.Code = null
            this.score.Day.Score.Type.Code = null
            this.score.WorkedTime = null
            this.score.GTM = null
            this.score.Holiday = false
            this.score.SGKEksikGunId = false
            this.score.IsGTM = false
            this.score.IsHTM = false
            this.score.Locked = false
            this.score.BranchId = false
            this.score.SGKJobNoticeId = false
        },
        clearAdditionalForm(){
            this.additional.EmployeeId = null
            this.additional.Month = null
            this.additional.Year = null
            this.additional.Time = null
            this.additional.TIP = null
            this.additional.SIRA_NO = null 
            this.additional.SystemCalculated = null
            this.additional.SGKJobNoticeId = null
        },
        editAdditional(d,tip,sira){
            this.clearAdditionalForm()
            this.additional.EmployeeId = d.Employee?.Id || null
            this.additional.Month = this.month
            this.additional.Year = this.year
            this.additional.TIP = tip
            this.additional.SIRA_NO = sira
            this.additional.SystemCalculated = sira == 35 ? d.FM : d.HTM
            this.additional.Time = (tip==1 && sira == 35) ? d.MonthlyFM : d.MonthlyHTM
            this.additional.BranchId = d?.OBranch?.Id
            this.additional.SGKJobNoticeId = d?.SGKJobNoticeId
            this.$showModal('additional')
        },
        createAdditional(){
            this.additionalCreating = true
            EmployeeOperationsApi.Score.InsertAdditional({
                ...this.additional,
                Driver:false
            }).then(res=>{
                this.additionalCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('additional')
                    this.checkUnsavedAndGetAll()
                }
            }).catch(err=>{
                this.additionalCreating = false
                this.$result(null,err)
            })
        },
        edit(driver,day,dayData){
            this.clearForm()
            this.score.Driver = driver
            this.score.Employee = driver
            this.score.Day.Date = day
            this.score.Day.DailyCheckStatus.Type.Code = dayData.DailyCheckStatus?.Type?.Code || null
            this.score.Day.Score.Type.Code = dayData.Score?.Type?.Code || null
            this.score.Day.Score.Type.Code = dayData.Score?.Type?.Code || null
            this.score.WorkedTime = dayData.PresaveWorkedTime || null
            this.score.GTM = dayData.GTM || null
            this.score.Holiday = this.getDayIsHoliday(day)
            this.score.SGKEksikGunId = dayData.SGKEksikGunId || null
            this.score.IsHTM = dayData.HTM == null ? false : true
            this.score.IsGTM = dayData.GTMFM == null && dayData.GTM == null ? false : true
            this.score.Locked = driver.Locked || false
            this.score.BranchId = driver.OBranch?.Id || null
            this.score.SGKJobNoticeId = driver.SGKJobNoticeId || null
            this.$showModal('edit-score')
        },
        search(){
            function search(){
                clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(()=>{ 
                    this.$emit('search',this.searchValue)
                    this.getAllMonthly() 
                },350)
            }
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(()=>{ search.call(this) },350)
        },
        checkUnsavedAndGetAll(){
            return new Promise((resolve)=>{
                if(this.c_unsaved > 0){
                    this.$confirm("Tarih değiştirmek istediğinize emin misiniz?",`${this.c_month} ${this.showingYear} için toplam ${this.c_unsaved} adet kaydedilmemiş puantaj değişikliği bulunmaktadır. Devam durumunda değişiklikler kaydedilmeyecektir.`).then(result=>{
                        if(result){
                            this.getAllMonthly().then(()=>resolve(true))
                        }
                    })
                }else this.getAllMonthly().then(()=>resolve(true))
            })
        },
        getDayName(day){
            return moment(day,'DD.MM.YYYY').locale('tr').format('ddd')
        },
        allSet(){
            this.serverData.forEach(e=>{
                Object.entries(e.Days).forEach(([day,value])=>{
                    if(value.CanEffect){
                        this.$set(value.Score.Type,'Code','N')
                        this.$set(value,'Unsaved',true)
                        this.$set(value,'Updated',true)
                        const wts = this.types.find(t=> t.Code == 'N')
                        if(wts){
                            this.$set(value.Score.Type,'Color',wts.Color)
                            this.$set(value.Score.Type,'Id',wts.Id)
                        }
                    }
                })
            })
            this.checkErrors()
        },
        updateScore(){
            this.presaving = true
            const ewtid = this.types.find(t=>t.Code == this.score.Day?.Score?.Type?.Code)?.Id || null
            EmployeeOperationsApi.Score.PreSave({
                EmployeeId:this.score.Driver?.Employee?.Id || null,
                Date:moment(this.score.Day.Date,"DD.MM.YYYY").format("YYYY-MM-DD"),
                WorkedTime:this.score.WorkedTime,
                NightWorkedTime:"00:00:00",
                EmployeeWorkingTypeId:ewtid,
                DriverCardNumber:null,
                GTM:this.score.GTM,
                SGKEksikGunId:this.score.SGKEksikGunId || null,
                IsHTM:this.score.IsHTM,
                IsGTM:this.score.IsGTM,
                Driver:false,
                BranchId:this.score.BranchId || null,
                SGKJobNoticeId:this.score.SGKJobNoticeId || null,
                BranchTypeCode:this.branchType,
            }).then(res=>{
                this.presaving = false
                this.$result(res)
                if(res.data.Success){
                    this.getAllMonthly()
                    this.$hideModal('edit-score')
                    this.clearForm()
                }
            }).catch(err=>{
                this.presaving = false
                this.$result(null,err)
            })

            // const employee = this.score.Driver?.Employee || null
            // if(employee){
            //     const scoreData = this.serverData.find(d=>d.Employee?.Id == employee?.Id)
            //     if(scoreData){
            //         this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Code',this.score.Day.Score.Type.Code)
            //         this.$set(scoreData.Days[this.score.Day.Date],'Unsaved',true)
            //         this.$set(scoreData.Days[this.score.Day.Date],'Updated',true)
            //         const wts = this.types.find(t=> t.Code == this.score.Day.Score.Type.Code)
            //         if(wts){
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Color',wts.Color)
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Id',wts.Id)
            //         }else{
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Color',null)
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Id',null)
            //             this.$set(scoreData.Days[this.score.Day.Date],'Unsaved',false)
            //             this.$set(scoreData.Days[this.score.Day.Date],'Updated',false)
            //         }
            //         this.checkErrors()
            //         this.$hideModal('edit-score')
            //         this.clearForm()
            //     }
            // }
        },
        hover(event){
            let element = event.target
            let selector = element.dataset.cellGroup
            document.querySelectorAll(`[data-cell-group='${selector}']`).forEach((e,i)=>e.classList.add(`nd-active-${i}`))
        },
        unhover(event){
            let element = event.target
            let selector = element.dataset.cellGroup
            document.querySelectorAll(`[data-cell-group='${selector}']`).forEach((e,i)=>e.classList.remove(`nd-active-${i}`))
        },
        showErrors(driver){
            this.scoreErrors = []
            this.scoreErrors.EmployeeName = [driver.Employee?.FirstName,driver.Employee?.LastName].join(' ') || ''
            this.scoreErrors.Errors = driver.DayErrors
            this.$showModal('score-errors')
        },
        getAllMonthly(){
            return new Promise((resolve)=>{
                this.loading = true
                EmployeeOperationsApi.NotDriverScore.AllMonthly({
                    PaginateRequest:{
                        Skip: this.currentPage,
                        Take: this.perPage,
                        QueryParam :this.searchValue || null,
                        OrderColumnName :null
                    },
                    BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                    BranchTypeCode:this.branchType,
                    CollarStatusId:this.collarStatus?.Id || null,
                    Month:this.month,
                    Year:this.year,
                    Day:1,
                    ...(this.exitAction?.employeeId && {EmployeeId:this.exitAction?.employeeId}),
                    ...(this.exitAction?.notifyDate && {ExitNotifyDate:this.exitAction?.notifyDate}),
                    ...(this.exitAction?.exitDate && {ExitDate:moment(this.exitAction?.exitDate).format('YYYY-MM-DD')})
                }).then(res=>{
                    resolve(true)
                    this.loading = false
                    if(!res.data.Success){
                        this.$result(res)
                    }else{
                        this.serverData = res.data.Data.Data
                        this.total = res.data.Data.TotalCount
                        this.showingYear = this.year
                        this.showingMonth = this.month
                        let date = moment(this.year+'-'+this.month,'YYYY-MM')
                        this.configureDaysOfMonth(date)
                        this.firstConfigure()
                        this.checkErrors()
                    }
                }).catch(err=>{
                    this.loading = false
                    this.$result(null,err)
                })
                // EmployeeOperationsApi.NotDriverScore.AllMonthly(this.month,this.year,1).then(res=>{
                //     resolve(true)
                //     this.loading = false
                //     this.serverData = res.data
                //     this.setTotal(res.data?.length)
                //     this.showingYear = this.year
                //     this.showingMonth = this.month
                //     let date = moment(this.year+'-'+this.month,'YYYY-MM')
                //     this.configureDaysOfMonth(date)
                //     this.firstConfigure()
                //     this.checkErrors()
                // }).catch(err=>{
                //     this.loading = false
                // })
            })
        },
        firstConfigure(){
            this.serverData.forEach(sd=>{
                this.$set(sd,'DayErrors',[])
                this.$set(sd,'Selected',false)
                !sd.RegisteredOnSystem ? sd.DayErrors.push({Type:'NotRegisteredOnSystem'}) : null
                Object.entries(sd.Days).forEach(([key,value])=>{
                    this.$set(value,'DailyCheckStatus',{Type:(value.DailyCheckStatus ? {...value.DailyCheckStatus} : null)})
                    if(value?.PresaveEWTCode){
                        const pwts = this.types.find(t=> t.Code == value.PresaveEWTCode)
                        if(pwts){
                            this.$set(value,'Score',{Type:{
                                Id:pwts.Id,
                                Code:pwts.Code,
                                Color:pwts.Color
                            }})
                        }
                    }else{
                        this.$set(value,'Score',{Type:{
                            Id: value.DailyCheckStatus?.Type?.Id ? value.DailyCheckStatus.Type.Id : null, 
                            Code: value.DailyCheckStatus?.Type?.Code ? value.DailyCheckStatus.Type.Code : null, 
                            Color: value.DailyCheckStatus?.Type?.Color ? value.DailyCheckStatus.Type.Color : null, 
                        }})
                    }
                    this.$set(value,'Updated',false)
                    this.$set(value,'DayIsBefore',null)
                    this.$set(value,'CanEffect',null)
                    this.$set(value,'HasNoData',false)
                    this.$set(value,'Unsaved',false)
                })
            })
        },
        checkErrors(){
            this.serverData.forEach(sd=> {
                this.$set(sd,'DayErrors',[])
                !sd.RegisteredOnSystem ? sd.DayErrors.push({Type:'NotRegisteredOnSystem'}) : null
            })
            this.configureConflictErrorAnHasNoData()
            this.configureRepeatEmptyDays()
            this.configureAllDaysNotWorking()
        },
        configureConflictErrorAnHasNoData(){
            this.serverData.forEach(sd=>{
                Object.entries(sd.Days).forEach(([key,value])=>{
                    let dailyCheckStatus = value.DailyCheckStatus?.Type?.Code || null
                    let score = value.Score?.Type?.Code ? value.Score?.Type?.Code == 'O' ? null : value.Score?.Type?.Code : null
                    if(this.exitAction != null) {
                        this.$set(value,'DayIsBefore',moment(key,'DD.MM.YYYY').isSameOrBefore(moment(this.exitAction.exitDate,'YYYY-MM-DD')))
                    }else{
                        this.$set(value,'DayIsBefore',moment(key,'DD.MM.YYYY').add(1,'days').isSameOrBefore(moment()))
                    }
                    this.$set(value,'CanEffect',value.Working && value.DayIsBefore)
                    if(dailyCheckStatus || score){
                        this.$set(value,'HasNoData',false)
                    }else {
                        this.$set(value,'HasNoData',true)
                    }
                })
            })
        },
        configureRepeatEmptyDays(){
            this.serverData.forEach(sd=>{
                Object.entries(sd.Days)
                    .map(([key,value])=>{ return { Day:key,...value } })
                    .reduce((err,day,index,arr)=>{
                        if(arr[index - 1]){
                            if(day.HasNoData == arr[index - 1].HasNoData && day.CanEffect == arr[index - 1].CanEffect && day.CanEffect){
                                err.at(-1).Count++
                                err.at(-1).DayEnd = arr[index].Day
                            }else{
                                err.at(-1).DayEnd = arr[index - 1].Day
                                err.push({CanEffect:day.CanEffect,DayStart:arr[index].Day,Value:day.HasNoData,Count:1,DayEnd:null })
                            }
                        }else{
                            err.push({CanEffect:day.CanEffect,DayStart:day.Day,Value:day.HasNoData,Count:1,DayEnd:null })
                        }
                        return err
                    },[]).filter(d=>d.Count >= 1 && d.Value && d.CanEffect).forEach(de=>{
                        sd.DayErrors.push({ Type:'RepeatEmpty',DayStart:de.DayStart,DayEnd:de.DayEnd,Count:de.Count })
                    })
            })
        },
        configureAllDaysNotWorking(){
            this.serverData.forEach(sd=>{
                let dayValues = Object.values(sd.Days)
                if(dayValues.filter(d=>!d.Working).length == Object.values(sd.Days).length){
                    sd.DayErrors.push({ Type:'NotRegisteredSgk'})
                }
            })
        },
        create(){
            this.saving = true
            const data = {
                Month:this.month,
                Year: this.year,
                Employees: this.serverData.filter(d=>d.Selected).map(d=>{
                    return  {
                        EmployeeId: d.Employee?.Id || null,
                        ExitDate:this.exitAction?.exitDate || null,
                        FM:d.TotalFM || null,
                        HTM:d.TotalHTM || null,
                        GTM:d.GTM || null,
                        SGKJobNoticeId:d.SGKJobNoticeId || null,
                        Days: Object.entries(d.Days).map(([key, value])=>{
                            const obj = {
                                Day: moment(key,"DD.MM.YYYY").format("YYYY-MM-DD"),
                                ScoreTaskId: value?.ScoreTaskId || null,
                                SGKEksikGunId:value?.SGKEksikGunId || null,
                                EmployeeWorkingTypeId: value?.Score?.Type?.Id || null,
                                CanEffect: value.CanEffect,
                                KYKMs: value.KYKMs,
                            }
                            return obj
                        }).filter(d=>d.CanEffect)
                    }
                })
            }
            EmployeeOperationsApi.Score.Create(data).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    this.getAllMonthly()
                }
            }).catch(err=>{
                this.saving = false
                this.$result(null,err)
            })
        },
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            if(this.exitAction?.exitDate){
                this.year = moment(this.exitAction.exitDate).year()
            }else this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = this.exitAction?.exitDate ? (moment(this.exitAction.exitDate).month() + 1) :  (moment().month() + 1)
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        hasUnsavedItem(number){
            return false
        },
        setTotal(value){
            this.total = value   
        },
        selectAll(){
            (this.serverData || []).filter(sd=>sd.DayErrors.length == 0).forEach(sd=>{
                this.$set(sd,'Selected',true)
            })
        },
    },
    computed:{
        c_month(){
            return this.months.find(m=> m.index == this.showingMonth)?.name || ""
        },
        c_totalError(){
            return this.serverData.reduce((sum,d)=>{
                sum += Object.values(d.Days).filter((day)=>day.HasConflict).length
                return sum
            },0)
        },
        c_unsaved(){
            return this.serverData.reduce((sum,d)=>{
                sum += Object.values(d.Days).filter((day)=>day.Unsaved).length
                return sum
            },0)
        },
        // c_items(){
        //     if(this.serverData){
        //         let items = this.serverData

        //         if(this.searchValue){
        //             items = items.filter(sd=> Additional.ToEng(sd.DriverFullName).toLowerCase().includes(Additional.ToEng(this.searchValue).toLowerCase()))
        //         }

        //         if(this.filterError == true){
        //             items = items.filter(sd=> sd.DayErrors.length > 0)
        //         }else if(this.filterError == false){
        //             items = items.filter(sd=> sd.DayErrors.length == 0)
        //         }

        //         if(this.branch){
        //             items = items.filter(sd=> sd.Branch?.Id == this.branch?.Id)
        //         }

        //         this.setTotal(items?.length)
        //         return items.slice((this.currentPage-1)*this.perPage,this.currentPage*this.perPage)
        //     }else {
        //         this.setTotal(0)
        //         return []
        //     }
        // },
        c_selected(){
            return this.serverData.filter(sd=>sd.Selected).length
        },
        c_unsavedItemsPage(){
            return this.serverData.filter(sd => Object.values(sd.Days).filter(d=>d.Unsaved).length || false).reduce((arr,sd)=>{
                const index = this.serverData.findIndex(d=>d.Employee?.Id == sd.Employee?.Id)
                if(index){
                    const page = Math.ceil((index + 1) / this.perPage)
                    arr.push(page)
                }
                return arr
            },[])
        },
        c_types(){
            return (this.types || []).filter(t => t.Code != 'K' && t.Code != 'C' && t.Code != 'Y').sort((a,b) => a.SIRA_NO - b.SIRA_NO)
        }
    },
    beforeRouteLeave (to, from,next) {
        if(this.c_unsaved > 0){
            this.$confirm("Çıkmak istediğinize emin misiniz?",`${this.c_month} ${this.showingYear} için toplam ${this.c_unsaved} adet kaydedilmemiş puantaj değişikliği bulunmaktadır. Devam durumunda değişiklikler kaydedilmeyecektir.`).then(result=>{
                if(result){
                    next()
                }else{
                    next(false)
                }
            })
        }else next()
    }
}
</script>

<style lang="scss">
@use "sass:map";

$types-bg:(
    'indigo': #8888ca,
    'pink': #a17191,
    'green': #83974a,
    'purple': #9a779b,
    'light-orange': #c1aca8,
    'dark-green': #9a997e,
    'yellow': #c7bf41,
    'red': #bc797e,
    'clean': #ffffff,
    'orange': #a87a4e,
    'teal': #8cbde5,
    'blue': #46b5d4,
    'gray': #9ea3c0,
);

$types-color:(
    'indigo': hsl(240, 38%, 33%),
    'pink': hsl(320, 20%, 21%),
    'green': hsl(76, 34%, 11%),
    'purple': hsl(298, 15%, 21%),
    'light-orange': hsl(10, 17%, 38%),
    'dark-green': hsl(58, 12%, 21%),
    'yellow': hsl(56, 54%, 19%),
    'red': hsl(356, 33%, 28%),
    'clean': hsl(0, 0%, 0%),
    'orange': hsl(29, 37%, 15%),
    'teal': hsl(207, 63%, 38%),
    'blue': hsl(193, 62%, 22%),
    'gray': hsl(231, 21%, 36%),
);

$types-bg-color:(
    'indigo': hsl(240, 38%, 65%),
    'pink': hsl(320, 20%, 53%),
    'green': hsl(76, 34%, 43%),
    'purple': hsl(298, 15%, 53%),
    'light-orange': hsl(10, 17%, 60%),
    'dark-green': hsl(58, 12%, 53%),
    'yellow': hsl(56, 54%, 51%),
    'red': hsl(356, 33%, 60%),
    'clean': hsl(0, 0%, 62%),
    'orange': hsl(29, 37%, 55%),
    'teal': hsl(207, 63%, 65%),
    'blue': hsl(193, 62%, 60%),
    'gray': hsl(231, 21%, 63%),
);

@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color !important;
        color: map.get($types-color,$class) !important;
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 30%);
        color: map.get($types-color,$class) !important;
    }
};

.per-page span{
    font-size: 0.85rem;
}

.type{
    border-radius: 0.75rem;
    font-size: 0.9rem;
}

.type > div{
    height: 22px;
    font-size: 0.75rem;
    border-radius: 0.5rem;
    padding: 0 0.25rem;
    min-width: 22px;
}

.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}

.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103);
}


.error-marker{
    color:var(--secondary);
    border-radius: 0.25rem;
    box-shadow: inset 0 0 0 2px var(--secondary);
    padding: 0.35rem 0.5rem;
}

.cell-group{
    cursor: pointer;
}

.cell-group.nd-score-error-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--secondary),
                inset 0 -2px 0 0 var(--secondary),
                inset 2px 0 0 0 var(--secondary) !important;
}
.cell-group.nd-score-error-1{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--secondary),
                inset 0 -2px 0 0 var(--secondary),
                inset -2px 0 0 0 var(--secondary) !important;
}


.cell-group.nd-score-ihbar-0{
    --ihbar: #F652A0;
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--ihbar),
                inset 0 -2px 0 0 var(--ihbar),
                inset 2px 0 0 0 var(--ihbar) !important;
}
.cell-group.nd-score-ihbar-1{
    --ihbar: #F652A0;
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--ihbar),
                inset 0 -2px 0 0 var(--ihbar),
                inset -2px 0 0 0 var(--ihbar) !important;
}

.cell-group.nd-active-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--primary),
                inset 0 -2px 0 0 var(--primary),
                inset 2px 0 0 0 var(--primary) !important;
}
.cell-group.nd-active-1{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--primary),
                inset 0 -2px 0 0 var(--primary),
                inset -2px 0 0 0 var(--primary) !important;
}

.cell-error-indicator{
    box-shadow: inset 0 0 0 2px var(--danger);
}
.cell-indicator-icon{
    font-size: 16px;
}
.cell-ihbar-indicator{
    box-shadow: inset 0 0 0 2px #F652A0;
    color: #F652A0 !important;
}

.sticky-status{
    background-color: white;
    position: sticky;
    top: 0px;
    z-index: 100;
}
.dark-layout .sticky-status{
    background-color: #283046 !important;
}

.date-header{
    font-size: 2.5rem;
    line-height: 1.2;
}

.small-not{
    display: flex;
    align-items: center;
    justify-content: center;
    width:1.125rem;
    height:1.125rem;
    border-radius: 1rem;
    font-size: 0.875rem;
    position: absolute;
    right:0.25rem;
    top:0.25rem;
    color:white;
}

.small-box{
    position: absolute;
    top: 2px;
    right: 2px;
    font-size: 0.5rem;
    padding: 0.1rem;
    font-weight: bold;
    border-radius: 0.1rem;
}

</style>